

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class SignInService {
  constructor(private http: HttpClient) {
  }

  PasswordSignIn(username: string, password: string): Observable<any> {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    return this.http.post(environment.apiUrl + '/api-token-auth', formData).pipe(map(data => data));
  }

  SignOutApp(): Observable<object> {
    return this.http.get(environment.apiUrl + '/dashboard/logout').pipe(map(data => data));
  }
}
